import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { isUuid } from '@mkp/shared/models';
import { AppConfig } from '@mkp/shared/util-app-config';
import { QUERY_PARAMS_ID } from '@mkp/shared/util-router';

const { routes } = AppConfig;

/**
 * Before the `/vacancy/:id` hub, `/vacancy/:id` redirected to the applications list, so a link
 * carrying a candidate, `?id=<applicationId>`, opened that candidate. The URL now renders the job
 * ad, which ignores `?id=`. This sends those links on to the applications with the whole query and
 * the fragment. Without `?id=` it declines, and the job ad renders as designed.
 *
 * `:id` must be a uuid, so `/vacancy/new?id=…` stays on the create form.
 */
export const legacyApplicationLinkGuard: CanMatchFn = (_route, _segments, snapshot) => {
  const router = inject(Router);
  const workspaceId = snapshot?.paramMap.get('workspaceId');
  const vacancyId = snapshot?.paramMap.get('id') ?? '';
  const applicationId = snapshot?.queryParamMap.get(QUERY_PARAMS_ID);

  return workspaceId && isUuid(vacancyId) && applicationId
    ? router.createUrlTree(
        ['/', routes.workspace, workspaceId, routes.vacancy, vacancyId, routes.applications],
        { queryParams: snapshot?.queryParams, fragment: snapshot?.fragment ?? undefined }
      )
    : false;
};
